<template>
  <div id="home" v-loading.fullscreen.lock="changeLoading">
    <div style="background-color: white; margin: 10px 20px">
      <div class="pos_container_panel" style="padding-left: 2rem">
        <div>
          <!-- 搜索 area -->
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
            style="margin-left: 6rem; padding-top: 2rem"
          >
            <el-row style="">
              <el-col :span="16"
                ><div class="grid-content bg-purple">
                  <el-form-item label="设施">
                    <el-select
                     default-first-option
                      filterable
                      v-model="searchForm.facility"
                      placeholder="设施"
                      style="width: 80%; margin-left: 3.5rem"
                      @change="selectFacility"
                      clearable
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.type"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item></div
              ></el-col>
              <el-col :span="8"
                ><div class="grid-content bg-purple-light"></div
              ></el-col>
              <el-col :span="8"
                ><div class="grid-content bg-purple"></div
              ></el-col>
            </el-row>
            <el-row>
              <el-col :span="24" style="float: right">
                <div class="grid-content bg-purple-light" style="float: right">
                  <el-button type="warning" class="harpIDbtn" @click="search()">
                    搜索</el-button
                  >
                  <el-button
                    type="warning"
                    class="harpIDbtn"
                    style="margin-left: 3rem"
                    @click="addNew()"
                  >
                    新增
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <hr
            style="
              margin: 1rem -14rem 0rem;
              background-color: rgb(241 243 245);
              height: 0.2rem;
              border: none;
            "
          />
          <el-table
            :data="tableData"
            border
            style="width: 90%; margin-top: 50px; margin-left: 100px"
          >
            <el-table-column prop="type" label="设施类型" align="center">
              <template #default="{ row }">
                <span>{{ getTypeLabel(row.type) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="code"
              label="设施编码"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="facilityNameLists.zh-CN"
              label="设施名称-中文"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="facilityNameLists.en"
              label="设施名称英文"
              align="center"
            ></el-table-column>
           <el-table-column label="操作" width="132" align="center">
              <template #default="scope">
                <el-button @click="handleChange(scope.row)" type="text" size="small">修改</el-button>
                <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-bottom: 1rem">
            <el-pagination
              class="paginationsty"
              background
              @current-change="handleCurrentChange"
              v-model:current-page="currentPage"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="searchForm.total"
            >
            </el-pagination>
          </div>
          </div>
          <!--新增 dialog-->
          <el-dialog title="新增设施" v-model="dialogNew">
            <el-form :model="form" ref="checkInput">
              <el-form-item
                prop="type"
                label="设施类型:"
                :label-width="formLabelWidth"
                :rules="[
                  {
                    required: true,
                    message: '请选择设施类型',
                    trigger: 'change',
                  },
                ]"
              >
                <el-select
                 default-first-option
                  filterable
                  v-model="form.type"
                  placeholder="请选择"
                  style="width: 58%; margin-left: 85px"
                  @change="selectNewFacility"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.type"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="设施编码:"
                :label-width="formLabelWidth"
                prop="code"
                :rules="[
                  {
                    required: true,
                    message: '请输入设施编码',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="form.code"
                  autocomplete="off"
                  style="width: 58%; margin-left: 85px"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="设施名称-中文:"
                :label-width="formLabelWidth"
                prop="facilitiesCH"
                :rules="[
                  {
                    required: true,
                    message: '请输入设施名称-中文',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="form.facilitiesCH"
                  autocomplete="off"
                  style="width: 58%; margin-left: 85px"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="设施名称-英文:"
                :label-width="formLabelWidth"
                prop="facilitiesEN"
                :rules="[
                  {
                    required: true,
                    message: '请输入设施名称-英文',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="form.facilitiesEN"
                  autocomplete="off"
                  style="width: 58%; margin-left: 85px"
                ></el-input>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button type="primary" @click="dataSave()">保存</el-button>
                <el-button @click="cancel()">取 消</el-button>
              </span>
            </template>
          </el-dialog>
          <!--修改dialog-->
          <el-dialog title="修改设施" v-model="dialogChange">
            <el-form :model="changeForm" ref="checkInput">
              <el-form-item
                prop="type"
                label="设施类型:"
                :label-width="formLabelWidth"
              >
                <el-select
                  disabled
                  v-model="changeForm.type"
                  placeholder="请选择"
                  style="width: 58%; margin-left: 85px"
                  @change="selectFacility"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="设施编码:"
                :label-width="formLabelWidth"
                prop="code"
              >
                <el-input
                  disabled
                  v-model="changeForm.code"
                  autocomplete="off"
                  style="width: 58%; margin-left: 85px"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="设施名称-中文:"
                :label-width="formLabelWidth"
                prop="facilitiesCH"
                :rules="[
                  {
                    required: true,
                    message: '请输入设施名称-中文',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="changeForm.facilitiesCH"
                  autocomplete="off"
                  style="width: 58%; margin-left: 85px"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="设施名称-英文:"
                :label-width="formLabelWidth"
                prop="facilitiesEN"
                :rules="[
                  {
                    required: true,
                    message: '请输入设施名称-英文',
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  v-model="changeForm.facilitiesEN"
                  autocomplete="off"
                  style="width: 58%; margin-left: 85px"
                ></el-input>
              </el-form-item>
            </el-form>
            <template #footer>
              <span class="dialog-footer">
                <el-button type="primary" @click="changeSave()">保存</el-button>
                <el-button @click="cancel()">取 消</el-button>
              </span>
            </template>
          </el-dialog>
        </div>
      </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <el-dialog title="警告" v-model="dialogDelete" width="30%">
      <span>将删除当前所有设施信息，请确认是否删除</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { facilities, facilitySave, facilityDelete } from "@/api/shoppingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
export default {
  name: "HBEFacility",
  components: { ConfirmBoxs },
  data() {
    return {
      changeLoading: false,
      confirmFlag: false,
      confirmIcon: "",
      confirmMsg: "",
      facilityCode: "",
      facilityType: "",
      newFacilityType: "",
      currentPage: 1,
      dialogNew: false,
      dialogChange: false,
      dialogDelete: false,
      deleteID: "",
      deleteParams: {},
      options: [
        {
          type: 1,
          value: "FCT01",
          label: "前台服务",
        },
        {
          type: 2,
          value: "FCT02",
          label: "餐饮服务",
        },

        {
          type: 3,
          value: "FCT03",
          label: "通用设施",
        },
        {
          type: 4,
          value: "FCT04",
          label: "休闲娱乐",
        },
        {
          type: 5,
          value: "FCT05",
          label: "其它",
        },
      ],
      searchForm: {
        facility: "",
      },
      form: {
        type: "",
        code: "",
        facilitiesCH: "",
        facilitiesEN: "",
      },
      changeForm: {
        type: "",
        code: "",
        facilitiesCH: "",
        facilitiesEN: "",
      },
      formLabelWidth: "150px",
      tableData: [],
    };
  },
  mounted() {},

  methods: {
    getTypeLabel(type) {
      const item = this.options.find(option => option.type === type)
      return item ? item.label : ''
    },
    // 分页
    handleCurrentChange(val) {
      this.search(val);
    },
    selectFacility(type) {
      this.facilityType = type;
    },
    selectNewFacility(type) {
      this.newFacilityType = type;
    },
    addNew() {
      this.dialogNew = true;
    },
    //新增保存
    dataSave() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            type: this.newFacilityType,
            code: this.form.code,
            name: this.form.facilitiesCH,
            desc: "",
            icon: "",
            facilityNames: [
              {
                languageCode: "en",
                name: this.form.facilitiesEN,
                description: "",
              },
              {
                languageCode: "zh-CN",
                name: this.form.facilitiesCH,
                description: "",
              },
            ],
          };
          this.saveNew(saveParams);
          this.$refs.checkInput.clearValidate();
          // this.dialogNew = false;
        }
      });
    },
    async saveNew(saveParams) {
      await facilitySave(saveParams)
        .then((res) => {
          if (res.code === 200) {
            this.form.type = "";
            this.form.code = "";
            this.form.facilitiesCH = "";
            this.form.facilitiesEN = "";
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "新增成功";
            this.dialogNew = false;
            this.search();
          } else {
            // this.form.type = "";
            // this.form.code = "";
            // this.form.facilitiesCH = "";
            // this.form.facilitiesEN = "";
            this.confirmFlag = true;
            this.confirmMsg = res.message; //"新增失败";
            this.changeLoading = false;
            // this.search();
          }
        })
        .catch(function (error) {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "新增失败";
          this.search();
        });
    },
    // 取消
    cancel() {
      this.form.type = "";
      this.form.code = "";
      this.form.facilitiesCH = "";
      this.form.facilitiesEN = "";
      this.$refs.checkInput.clearValidate();
      this.dialogNew = false;
      this.dialogChange = false;
    },
    //修改
    handleChange(row) {
      this.changeForm.id = row.id;
      this.changeForm.type = row.type;
      this.changeForm.code = row.code;
      this.changeForm.facilitiesCH = row.facilityNameLists["zh-CN"];
      this.changeForm.facilitiesEN = row.facilityNameLists["en"];
      this.dialogChange = true;
    },
    //修改保存
    changeSave() {
      this.$refs["checkInput"].validate((valid) => {
        if (valid) {
          this.changeLoading = true;
          let saveParams = {
            id: this.changeForm.id,
            type: this.changeForm.type,
            code: this.changeForm.code,
            name: this.changeForm.facilitiesCH,
            desc: "",
            icon: "",
            facilityNames: [
              {
                languageCode: "en",
                name: this.changeForm.facilitiesEN,
                description: "",
              },
              {
                languageCode: "zh-CN",
                name: this.changeForm.facilitiesCH,
                description: "",
              },
            ],
          };
          this.saveChange(saveParams);
          this.$refs.checkInput.clearValidate();
          // this.dialogChange = false;
        }
      });
    },
    async saveChange(saveParams) {
      await facilitySave(saveParams)
        .then((res) => {
          if (res.code === 200) {
            this.changeLoading = false;
            this.confirmFlag = true;
            this.confirmMsg = "修改成功";
            this.dialogChange = false;
            this.search();
          } else {
            this.confirmFlag = true;
            this.confirmMsg = res.message; //"修改失败";
            this.changeLoading = false;
          }
        })
        .catch(function (error) {
          this.confirmFlag = true;
          this.confirmMsg = "修改失败";
          this.search();
        });
    },
    // 删除
    deleteRow(row) {
      this.dialogDelete = true;
      this.deleteparams = {
        params: {
          code: row.code,
        },
      };
    },
    cancelDelete() {
      this.dialogDelete = false;
    },
    confirmDelete() {
      this.dialogDelete = false;
      facilityDelete(this.deleteparams).then((res) => {
        if (res.code === 200) {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "删除成功";
          this.deleteFlag = false;
          this.search();
        } else {
          this.changeLoading = false;
          this.confirmFlag = true;
          this.confirmMsg = "删除失败";
          this.deleteFlag = false;
          this.search();
        }
      });
    },
    // 搜索
    search(int) {
      this.changeLoading = true;
      let searchparams = {
        params: {
          code: "",
          type: this.facilityType ? this.facilityType : null,
          page: int ? int : 1,
          per_page: 10,
        },
      };
      facilities(searchparams)
        .then((res) => {
          if (res.code == 200) {
            this.changeLoading = false;
            this.currentPage = res.data.pageNumber;
            this.tableData = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "搜索设施信息失败，请稍后重试";
            this.changeLoading = false;
          }
        })
        .catch((error) => {
          this.changeLoading = false;
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
  },
};
</script>
<style scoped>
.loading {
  z-index: 9999999;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0;
  font-size: 1rem;
}
.pos_container_panel {
  padding: 0 16rem 4rem;
}
.paginationsty {
  float: right;
  margin: 1rem 0;
}
</style>